<template>
  <div id="GoTop" @click="GoTop()">
    <!-- <span class="glyphicon glyphicon-chevron-up"></span> -->
    <img class="" src="@/assets/img/goTop.png" alt="">
  </div>
</template>
<script>
export default {
  name: "GoTop",
  data() {
    return {
      flag: false
    };
  },
  methods: {
    GoTop() {
      (function smoothscroll() {
        var currentScroll =
          document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          window.requestAnimationFrame(smoothscroll);
          window.scrollTo(0, currentScroll - currentScroll / 10);
        }
      })();
    }
  }
};
</script>
<style scoped>
#GoTop {
  width: 70px;
  height: 70px;
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 99999999;
  cursor: pointer;
}
#GoTop > img {
  display: block;
  width: 100%;
  height: 100%;
  /* color: rgb(8, 162, 233); */
  /* color: #e90003;
  font-size: 30px; */
}
</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue